import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';
import ShopServiceModel from '@/models/ShopServiceModel';

@model.cacheDuration()
@model.urnResource('product_variant_sales_status')
@doc.path('/product_variant_sales_statuses/{?id}')
export default class ProductVariantSalesStatusModel extends ShopServiceModel {
	private declare _tsFilters: {
		'reference': Shop_ProductVariantSalesStatusReference;
	};

	private declare _tsSorts: {
		'id': string;
		'label': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Shop_ProductVariantSalesStatusReference;

	public get color() {
		switch (this.reference) {
			case 'sold_out':
				return 'red';
			case 'available':
				return 'green';
		}
	}
}